export const COOKIEHUB_GLOBAL_VAR = 'cookiehub';
